import { gql } from '@apollo/client'

const listFileType = gql(`
  query listFileType($module: String!, $project:String, $limit: Int, $nextToken: String)
  {
    listFileType(
      module : $module
      project : $project
      limit : $limit
      nextToken : $nextToken
    ){
      items{
        id
        name
        isEnabled
        extension
        usageCount
        key
      }
      nextToken
    }
  }
`)

export default listFileType
